<template>
<!-- 
  Author: lan.h
  Date: 2021-10-20
  content: 支持机构
-->
  <div class="vb100" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="p_head">
      <div class="p_title">
        <p>ORGANIZATION</p>
        <h1>支持机构</h1>
      </div>
      <div class="p_links">
        <div class="links-item js-lower-anchor" v-for="item in year_list" :key="item.id" @click="yearChange(item)">
          <p class="links-name" :class="active_year == item.id ? 'active' : ''">{{item.name}}</p>
        </div>
      </div>
    </div>
    <div class="org-content">
      <div class="list-content">
        <div class="info" v-for="item in org_list" :key="item.value">
          <div class="list-title">{{item.name}}</div>
          <div class="list-org">
            <div class="org-item" v-for="org, index in item.arr" :key="index">
              <img :src="org.logo_path | logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSupportOrganizationYear, getSupportOrganization } from '@/service/main.js'
export default {
  data() {
    return {
      loading: false,
      org_list: [],
      year_list: [],
      active_year: ''
    }
  },
  created() {
    this.getSupportOrganizationYear()
  },
  computed: {
    vb100_org_type() {
      return this.$store.state.list_meta.vb100_org_type
    }
  },
  methods: {
    //获取年数据
    async getSupportOrganizationYear() {
      let res = await getSupportOrganizationYear({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.$set(this.$data, 'year_list', res.res)
        if(res.res.length > 0){
          this.active_year = res.res[0].id
          this.getSupportOrganization(res.res[0].id)
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    //获取机构数据
    async getSupportOrganization(awards_year_id) {
      this.loading = true
      let res = await getSupportOrganization({
        awards_year_id: awards_year_id
      }, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.org_list = []
        this.vb100_org_type.forEach(item =>{
          let arr = res.res.filter(e => e.type == item.value) || []
          if(arr.length > 0){
            let temp = {...item}
            temp.arr = arr
            this.org_list.push(temp)
          }
        })
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    yearChange(val) {
      this.active_year = val.id
      this.getSupportOrganization(val.id)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/main/list.stylus';
.p_head
  width 1200px
  margin 0 auto
  .p_links
    right 0
    .links-item
      height 30px
    .active
      color #D9BB9E
.org-content
  margin-top 60px
  min-height 50vh
  .info
    margin-bottom 25px
  .list-org
    display flex
    flex-flow row wrap
    width 860px
    .org-item
      width 160px
      height 55px
      display flex 
      justify-content center 
      align-items center
      margin-right 14px
      background #FFFFFF
      box-shadow 0px 2px 6px 0px rgba(121, 133, 143, 0.1)
      border-radius 4px
      margin-bottom 14px
      img 
        max-width 100%
        max-height 100%
      &:nth-child(5n)
        margin-right 0
</style>